import React, { ReactElement } from 'react';

export type Step = {
	number: number;
	title: ReactElement;
	titleMob: string;
	description: string;
};

export const stepsDb: Step[] = [
	{
		number: 1,
		titleMob: 'Запишитесь на консультацию',
		title: (
			<>
				Запишитесь <br /> на консультацию
			</>
		),
		description:
			'Проконсультируем вас и оформим замер. В течение 3-х дней после замера подготовим смету на товары и услуги',
	},
	{
		number: 2,
		title: (
			<>
				Ознакомьтесь <br />с договором
			</>
		),
		titleMob: 'Ознакомьтесь с договором',
		description:
			'Вышлем вам договор и смету — оплатить можно онлайн или в магазине. Или оформить кредит',
	},
	{
		number: 3,
		title: (
			<>
				Выберите <br />
				удобную дату
			</>
		),
		titleMob: 'Выберите удобную дату',
		description:
			'Согласуем дату для доставки товаров и начала черновых работ — будем рядом на всех этапах',
	},
	{
		number: 4,
		title: (
			<>
				Примите <br />
				работы
			</>
		),
		titleMob: 'Примите работы',
		description:
			'С нами вы можете сделать и другие этапы ремонта — укладка пола, покраска стен, установка дверей и многое другое',
	},
];
